import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { webSocket } from 'rxjs/webSocket';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebSocketClientService {
  private socket$: any;
  username: string | null= null;;
  idOrganizacao: string | null= null;;

  nomeCliente: string | null= null;;
  telefoneCliente: string | null= null;;
  emailCliente: string | null= null;;



  public clientConnect(chatTicketId: any, nome: string|null, email: string|null, empresa: string|null): void {

      
    var urlSocket = environment.websocketClientUrl+'?chatTicketId='+chatTicketId+'&name='+nome+'&email='+email+'&empresa='+empresa+'&phone=';
    //console.log('urlSocket', urlSocket);

    this.socket$ = webSocket(urlSocket);
    console.log(this.socket$);
    this.socket$.subscribe();
  }

  sendMessage(message: any): void {
    console.log('### SOCKET sendMessage', message)
    if (this.socket$) {
      this.socket$.next(message);
    }
  }


  public getMessages(): Observable<any> {
    //console.log('### SOCKET getMessages '+this.socket$)
    if (!this.socket$) {
      alert('Você está desconectado. É preciso sair do sistema e entrar novamente.');
      //this.connect();
      // Swal.fire({
      //   title : 'Atenção',
      //   text : 'Você está desconectado. É preciso sair do sistema e entrar novamente.',
      //   icon : 'warning',
      //   confirmButtonColor : 'var(--theme-deafult)',
      // })
      // throw new Error('Please connect to the WebSocket first.');
    }
    return this.socket$.asObservable();
  }

  public disconnect(): void {
    console.log('### SOCKET disconnect')
    if (this.socket$) {
      this.socket$.complete();
    }
  }
}
